import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { MapService } from 'src/app/services/map.service';
import { ILabel } from './models/labels.interface';
import { IRangeDate } from './models/graph-data.interface';
//import * as mapboxgl from 'mapbox-gl';
import mapboxgl from 'mapbox-gl';
window.mapboxgl = mapboxgl;
import MapboxCompare from 'mapbox-gl-compare';
import { environment } from 'src/environments/environment';
import { GraphComponent } from './graph/graph.component';
import { WellsService } from 'src/app/services/wells.service';
import { IWell } from './models/wells.inteface';
import { Subject, forkJoin, map, take, takeUntil } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { FieldsModalComponent } from './fields-modal/fields-modal.component';

interface IShowMenu {
  [key: string]: boolean;
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnDestroy, OnChanges {
  @Input() longitude!: number;
  @Input() latitude!: number;
  @Input() detail!: any;
  @Input() zoomDefault = 10;
  @ViewChild(GraphComponent) graphComponent: GraphComponent | undefined;
  private fieldSelected: number = 1;
  private destroy$ = new Subject();

  public showMenu: IShowMenu = {
    sidebar: true,
    periodos: false,
    graph: false,
    fields: false,
  };
  public showAfterMap: boolean = false;
  public showSideBar: boolean = true;
  public showGraph: boolean = false;
  public timeRange: boolean = false;
  public timeMoment: boolean = false;
  public timeRangeC: boolean = false;
  public timeMomentC: boolean = false;
  public alert : boolean = false;
  public selectedLayers: boolean = false;
  public layersSelected: any[] = [];
  public layersSelectedCompare: any[] = [];
  public labelList: ILabel[] = [];
  public wellList: IWell[] = [];
  public treeList: any[] = [];
  public rangeDate!: IRangeDate;
  public fullScreenGraphs: boolean = false;
  public isToastOpen = false;
  public message = '';
  public labelGraph: ILabel[] = [];
  public periodDate: Date = new Date(
    new Date().getFullYear() - 2,
    new Date().getMonth(),
    new Date().getDate()
  );
  public periodDateC = { start: new Date(), end: new Date() };
  public momentDateC = new Date(
    new Date().getFullYear() - 2,
    new Date().getMonth(),
    new Date().getDate()
  );
  public map!: mapboxgl.Map;
  public afterMap!: mapboxgl.Map;
  public compare!: MapboxCompare;
  public wellListNew: IWell[] = [];
  public dmuSelected: string = '';
  public rangeDateSend: any;
  public rangeDateSendCompare: any;

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {}

  constructor(
    public _mapService: MapService,
    public loadingService: LoadingService,
    private wellsService: WellsService,
    private modalCtrl: ModalController
  ) {
    _mapService.temporalSerie$.subscribe(((data) => {
      if(data.show && data.dmu){
        this.showGraph = true;
        this.dmuSelected = data.dmu;
      }
    }))
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['latitude']?.previousValue) {
      changes['latitude'].currentValue != changes['latitude'].previousValue &&
        this.getDataLabelByBounds();        
    }else if(changes['detail']?.currentValue){
      const data = changes['detail']?.currentValue;
      
      setTimeout(() => {
        if(data?.model){
          const origin = {
            lon: data.coordinates[0],
            lat:  data.coordinates[1],
            model_setting_color: data.model_setting_color,
            model_setting_z: data.model_setting_z,
            name: data.name,
            dmu_name: data.dmu_name,
            description: data.description,
            ...data
          };
          this._mapService.addALert3d(data.model,data.id, [origin], data)
          this._mapService.setCenterMap(origin.lat, origin.lon, 18)          
        }
        
      }, 1000);
    }
  }

  
  ngOnDestroy(): void {
    this.destroy$.next(null);
  }

  ngOnInit() {
    mapboxgl.accessToken = environment.MAPBOX_KEY;
    this.map = new mapboxgl.Map({
      container: 'after',
      style: this._mapService.style,
      center: [this.longitude, this.latitude],
      zoom: this.zoomDefault,
      pitch: 0,
      antialias: true
    });
       
    this.afterMap = new mapboxgl.Map({
      container: 'before',
      style: this._mapService.style,
      center: [this.longitude, this.latitude],
      zoom: this.zoomDefault,
      pitch: 0,
      antialias: true
    });
    this.onMapLoad(this.map, this.afterMap);
  }

  onMapLoad(map: any, afterMap: any) {
    this._mapService.map = map;
    this._mapService.afterMap = afterMap;
    this._mapService.compare = this.compare;
    this._mapService.initMap();
    this._mapService.initMap2();
    this.getDataLabelByBounds();
    this.resize();    
  }
  resize() {
    setTimeout(() => {
      this._mapService.map.resize();
      this._mapService.afterMap.resize();
      window.dispatchEvent(new Event('resize'));
    }, 10);
  }

  createCompare(){
    this.showAfterMap = false;
    this._mapService.createCompare();
  }

  removeCompare(){
    this.showAfterMap = true;
    this._mapService.compare.remove();    
  }

  getDataLabelByBounds() {
    this.loadingService.show()
    if (this._mapService.zoomLevel <= 7) {
      this.setOpen(true);
      this.message = 'En el nivel de zoom actual no se permite filtrar datos.';
    } else {
      const bounds = this._mapService.map.getBounds();
      forkJoin({
        tree: this._mapService.getTreeLabelByBounds(bounds),
        wells: this.wellsService.getWellByBounds(bounds),
      })
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe((resp) => {
          
          this.wellList = resp.wells;
          this.wellListNew = this.wellList.map((well) =>{ return {...well, field: 'Castilla'}})
          this.treeList = resp.tree;
          this.labelList = this.labelList.map((label) => {
            label.graphType = label.graph_type.type;
            return label;
          });
          this.graphComponent?.reset();
          this._mapService.getDmus(this.wellList, this.map);
          this._mapService.getDmus(this.wellList, this.afterMap);
          this.loadingService.hide()
          //this._mapService.addbuildings();
        });
    }
  }

  searchZone() {
    this._mapService.showSearchZone = false;
    this.getDataLabelByBounds();
  }

  setShowMenu(key: string) {
    if (key == 'sidebar') {
      this.showSideBar = !this.showSideBar;
    } else {
      for (let option in this.showMenu) {
        if (option != key) {
          this.showMenu[option] = false;
        }
      }
    }

    key == 'fields' && this.openModalFiels();
    this.showMenu[key] = !this.showMenu[key];
  }


  async openModalFiels() {
    const modal = await this.modalCtrl.create({
      component: FieldsModalComponent,
      cssClass: 'field-modal',
      componentProps: { fieldSelected: this.fieldSelected },
      backdropDismiss: false,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'cancel') {
      this.fieldSelected != data && this.getDataLabelByBounds();
      this.fieldSelected = data;
    }
  }

  setOpen(isOpen: boolean) {
    this.isToastOpen = isOpen;
  }

  showLGraph(event: any){
    this.labelGraph = event;
  }

  setRangeDate($event: Date, field = 'start') {
    this.rangeDate = {
      ...this.rangeDate,
      [field]: $event
    };
  }
  
}
